import { useBreakpointValue } from '@genial/utils';
import React, { useEffect, useState } from 'react';

import { ContainerDesktop } from './desktop';
import { ContainerMobile } from './mobile';

interface ValidateTokenProps {
  errorValidateToken: boolean;
  loadingToken: boolean;
  handleValidateToken: (value: string) => void;
}

export const ValidateToken: React.FC<ValidateTokenProps> = ({
  errorValidateToken,
  handleValidateToken,
  loadingToken,
}) => {
  const [value, setValue] = useState<string>('');
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setIsError(errorValidateToken);
  }, [errorValidateToken]);

  useEffect(() => {
    setIsError(false);
  }, [value]);

  const inputProps = {
    value,
    setValue,
    isError,
    loadingToken,
  };

  const responsiveContainer = useBreakpointValue({
    base: <ContainerMobile inputProps={inputProps} handleValidateToken={handleValidateToken} />,
    sm: <ContainerDesktop inputProps={inputProps} handleValidateToken={handleValidateToken} />,
  });

  return responsiveContainer;
};
